<template>
  <div>
    <div class="flex-container-password">
      <div class="card">
        <p class="title">
          <strong>{{ $t("passwordStrength.password") }}</strong>
        </p>
        <password
          v-model="password"
          :toggle="toggle"
          @score="showScore"
          @feedback="showFeedback"
          :secureLength="secureLength"
          :badge="badge"
          :showPassword="showPassword"
          :showStrengthMeter="showStrengthMeter"
          autocomplete="false"
        />
        <div>
          <ul>
            <li :class="rules.find((rule) => rule.name === 1).value">
              <span>{{ $t("passwordStrength.minLength") }}</span>
            </li>
            <li :class="rules.find((rule) => rule.name === 2).value">
              <span>{{ $t("passwordStrength.rulesUppercase") }}</span>
            </li>
            <li :class="rules.find((rule) => rule.name === 3).value">
              <span>{{ $t("passwordStrength.rulesLowercase") }}</span>
            </li>
            <li :class="rules.find((rule) => rule.name === 4).value">
              <span>{{ $t("passwordStrength.rulesDigits") }}</span>
            </li>
            <li :class="rules.find((rule) => rule.name === 5).value">
              <span>{{ $t("passwordStrength.rulesSpecial") }}</span>
            </li>
            <li
              :class="
                rulesConfirmPassword.find((rule) => rule.name === 1).value
              "
            >
              <span>{{ $t("passwordStrength.samePasswordConfirm") }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="card">
        <p class="title">
          <strong>{{ $t("passwordStrength.confirmPassword") }}</strong>
        </p>
        <div data-v-101a2793="" class="Password">
          <div class="Password__group">
            <input
              :type="!passwordConfirmView ? 'password' : 'text'"
              class="Password__field"
              v-model="passwordConfirm"
              autocomplete="false"
            />
            <div class="Password__icons">
              <div class="Password__toggle">
                <button
                  type="button"
                  aria-label="Show Password"
                  tabindex="-1"
                  class="btn-clean"
                  @click="passwordConfirmViewClick"
                >
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <title>Show Password</title>
                    <path
                      v-if="!passwordConfirmView"
                      d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"
                    ></path>
                    <path
                      v-else
                      d="M12 9c1.641 0 3 1.359 3 3s-1.359 3-3 3-3-1.359-3-3 1.359-3 3-3zM12 17.016c2.766 0 5.016-2.25 5.016-5.016s-2.25-5.016-5.016-5.016-5.016 2.25-5.016 5.016 2.25 5.016 5.016 5.016zM12 4.5c5.016 0 9.281 3.094 11.016 7.5-1.734 4.406-6 7.5-11.016 7.5s-9.281-3.094-11.016-7.5c1.734-4.406 6-7.5 11.016-7.5z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <span class="text-danger">{{
          $t(
            passwordConfirm !== password
              ? "passwordStrength.samePassword"
              : null
          )
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Password from "vue-password-strength-meter";

export default {
  components: {
    Password,
  },
  props: {
    secureLength: {
      type: Number,
      default: 6,
    },
    toggle: {
      type: Boolean,
      default: true,
    },
    badge: {
      type: Boolean,
      default: true,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
    showStrengthMeter: {
      type: Boolean,
      default: true,
    },
  },
  name: "VuePasswordStrength",
  data: () => ({
    password: null,
    passwordConfirm: null,
    passwordMorning: null,
    passwordConfirmMorning: null,
    passwordConfirmView: false,
    score: 0,
    rules: [
      {
        name: 1,
        value: "uncheck",
      },
      {
        name: 2,
        value: "uncheck",
      },
      {
        name: 3,
        value: "uncheck",
      },
      {
        name: 4,
        value: "uncheck",
      },
      {
        name: 5,
        value: "uncheck",
      },
    ],
    rulesConfirmPassword: [
      {
        name: 1,
        value: "uncheck",
      },
    ],
    failRules: true,
  }),
  watch: {
    password: {
      handler: function (val) {
        this.validatePasswordRulesString(val);
      },
      deep: true,
    },
    passwordConfirm: {
      handler: function (val) {
        this.rulesConfirmPassword = [
          {
            name: 1,
            value: "uncheck",
          },
        ];

        if (this.passwordConfirm === this.password) {
          this.rulesConfirmPassword.find((rule) => rule.name === 1).value = "check";
          this.validatePasswordRulesString(this.password);
        } else {
          this.rulesConfirmPassword.find((rule) => rule.name === 1).value = "check";

          this.failRules = true;
        }

        this.emitePassword();
      },
      deep: true,
    },
  },
  methods: {
    validatePasswordRulesString(password) {
      console.log(password)
      const regex8Digitos = /^.{8,}$/;
      const regexLetraMaiuscula = /[A-Z]/;
      const regexLetraMinuscula = /[a-z]/;
      const regexCaractereEspecial = /[!@#$%^&*(),.?":{}|<>]/;
      const regexNumero = /\d/;

      this.rules = [
        {
          name: 1,
          value: "uncheck",
        },
        {
          name: 2,
          value: "uncheck",
        },
        {
          name: 3,
          value: "uncheck",
        },
        {
          name: 4,
          value: "uncheck",
        },
        {
          name: 5,
          value: "uncheck",
        },
      ];

      this.failRules = true;

      if (regex8Digitos.test(password)) {
        this.rules.find((rule) => rule.name === 1).value = "check";
      }

      if (regexLetraMaiuscula.test(password)) {
        this.rules.find((rule) => rule.name === 2).value = "check";
      }

      if (regexLetraMinuscula.test(password)) {
        this.rules.find((rule) => rule.name === 3).value = "check";
      }

      if (regexNumero.test(password)) {
        this.rules.find((rule) => rule.name === 4).value = "check";
      }

      if (regexCaractereEspecial.test(password)) {
        this.rules.find((rule) => rule.name === 5).value = "check";
      }

      if (
        regex8Digitos.test(password) &&
        regexLetraMaiuscula.test(password) &&
        regexLetraMinuscula.test(password) &&
        regexNumero.test(password) &&
        regexCaractereEspecial.test(password) &&
        this.passwordConfirm === this.password
      ) {
        this.failRules = false;
      }

      this.emitePassword();
    },
    showFeedback({ suggestions, warning }) {
      // console.log('🙏', suggestions)
      // console.log('⚠', warning)
    },
    passwordConfirmViewClick() {
      this.passwordConfirmView = !this.passwordConfirmView;
    },
    emitePassword() {
      if (this.score >= 1 && !this.failRules) {
        this.$emit("password", this.password);
      } else {
        this.$emit("password", null);
      }
    },
    showScore(score) {
      this.score = score;
      this.emitePassword();
    },
  },
};
</script>

<style scoped>
.flex-container-password {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: normal;
  align-content: normal;
}

.card {
  padding: 15px;
  width: 50%;
  border: none;
}

.Password {
  margin: unset;
}

li span {
  position: relative;
  left: 15px;
}

li.uncheck::marker {
  content: "\f057";
  font-family: FontAwesome;
  font-weight: normal;
  font-style: normal;
  color: #e34a4a;
}

li.check::marker {
  content: "\f05d";
  font-family: FontAwesome;
  font-weight: normal;
  font-style: normal;
  color: #c8f9c5;
}

.text-danger {
  color: #e34a4a;
}

@media only screen and (max-width: 992px) {
  .flex-container-password {
    flex-direction: column;
  }

  .card {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/form-elements/VuePasswordStrength.vue